<template>
  <section class="intro-page">
    <g-title tag="h1">{{ introPage.Title }}</g-title>
    <g-markdown :content="introPage.Text" />
    <g-title class="second-title" tag="h2" size="s">
      {{ introPage.SecondTitle }}
    </g-title>
    <g-markdown :content="introPage.SecondText" />
    <Checkbox v-model="gdpr" required class="gdpr">
      JAG HAR LÄST OCH ÄR OK MED ECPATS
      <a
        target="_blank"
        href="https://ecpat.se/integritetsmeddelande/"
        class="underline"
      >
        INTEGRITETSPOLICY
      </a>
    </Checkbox>
    <g-button
      :disabled="!gdpr"
      @click.prevent="$router.push({ name: 'form', query: { gdpr: true } })"
    >
      STARTA TESTET
    </g-button>
  </section>
</template>
<script>
import GET_INTRO_PAGE from '@/graphql/GetIntroPage.gql';
import Checkbox from '@/components/Checkbox';

export default {
  components: {
    Checkbox
  },
  apollo: {
    introPage: {
      query: GET_INTRO_PAGE
    }
  },
  data() {
    return {
      introPage: {
        Title: '',
        Text: '',
        SecondTitle: '',
        SecondText: ''
      },
      gdpr: false
    };
  }
};
</script>
<style lang="scss" scoped>
.second-title {
  margin-top: 50px;
}

.gdpr {
  margin-bottom: 30px;
}
</style>
